export const es = {
  translation: {
    Hello: "Hola",
    "Not a member?": "¿No eres miembro?",
    "Sign Up": "Registrarse",
    Affiliate: "Afiliado",
    "Sign In": "Iniciar Sesión",
    "Sign in If you have an account in here":
      "Inicia sesión si tienes una cuenta aquí",
    // New translations for AffiliateSignInForm
    "Your Email": "Tu Correo Electrónico",
    Email: "Correo Electrónico",
    Password: "Contraseña",
    "Enter Your Password": "Ingresa Tu Contraseña",
    "Forgot Password?": "¿Olvidaste tu Contraseña?",
    "Invalid email address": "Dirección de correo electrónico inválida",
    "Email is required": "El correo electrónico es requerido",
    "Password must be at least 6 characters long":
      "La contraseña debe tener al menos 6 caracteres",
    "Password is required": "La contraseña es requerida",
    // PasswordCard translations
    "Password Settings": "Configuración de Contraseña",
    "Current Password": "Contraseña Actual",
    "Enter your current password": "Ingresa tu contraseña actual",
    "New Password": "Nueva Contraseña",
    "Enter your new password": "Ingresa tu nueva contraseña",
    "Confirm New Password": "Confirmar Nueva Contraseña",
    "Confirm your new password": "Confirma tu nueva contraseña",
    "Change Password": "Cambiar Contraseña",
    "Current password is required": "La contraseña actual es requerida",
    "Password must be at least 8 characters":
      "La contraseña debe tener al menos 8 caracteres",
    "New password must be different from current password":
      "La nueva contraseña debe ser diferente a la actual",
    "New password is required": "La nueva contraseña es requerida",
    "Passwords must match": "Las contraseñas deben coincidir",
    "Please confirm your new password":
      "Por favor confirma tu nueva contraseña",
    // PersonalInfoCard translations
    "Personal Information": "Información Personal",
    Name: "Nombre",
    "Update Profile": "Actualizar Perfil",
    "First name must be at least 2 characters":
      "El nombre debe tener al menos 2 caracteres",
    "Name can only contain letters": "El nombre solo puede contener letras",
    "Name is required": "El nombre es requerido",
    // StripeConnectionCard translations
    "Stripe Connection": "Conexión de Stripe",
    Connected: "Conectado",
    "Not Connected": "No Conectado",
    "Your Stripe account is connected and ready to receive payments.":
      "Tu cuenta de Stripe está conectada y lista para recibir pagos.",
    "Connect your Stripe account to start receiving affiliate commissions.":
      "Conecta tu cuenta de Stripe para comenzar a recibir comisiones de afiliados.",
    "Connect with Stripe": "Conectar con Stripe",
    // BusinessCard translations
    Reviews: "Reseñas",
    // BusinessDesignForm translations
    "General Information": "Información General",
    // SplitLayout translations
    "Affiliate Portal": "Portal de Afiliados",
    "Join our affiliate network and earn commissions by helping businesses discover our platform. Connect local businesses with customers and earn rewards for every successful subscription.":
      "Únete a nuestra red de afiliados y gana comisiones ayudando a las empresas a descubrir nuestra plataforma. Conecta empresas locales con clientes y gana recompensas por cada suscripción exitosa.",
    // StripeConnectSuccess translations
    "Success! Your account is connected to Stripe successfully. Press OK to Continue.":
      "¡Éxito! Tu cuenta está conectada a Stripe exitosamente. Presiona OK para continuar.",
    OK: "OK",
    // Referrals translations
    "Referral QR code": "Código QR de referido",
    "Share your referral link": "Comparte tu enlace de referido",
    "Refer a New Client and Earn": "Refiere a un Nuevo Cliente y Gana",
    "50% Commission (first two months per company)": "50% de Comisión (primeros dos meses por empresa)",
    "How Does Our Referral Program Work?":
      "¿Cómo Funciona Nuestro Programa de Referidos?",
    "1. Share your unique referral link":
      "1. Comparte tu enlace de referido único",
    "2. When someone signs up using your link, they become your referral":
      "2. Cuando alguien se registra usando tu enlace, se convierte en tu referido",
    "3. Earn 50% commission for the first two months for each company you bring in":
      "3. Gana 50% de comisión los primeros dos meses por cada empresa que incorpores",
    "4. Get paid monthly via Stripe":
      "4. Recibe pagos mensuales a través de Stripe",
    "If a company cancels its membership, it does not count the following month.":
      "Si una empresa cancela su membresía, no cuenta el mes siguiente.",
    "Search referrals by name": "Buscar referidos por nombre",
    "Registration Date": "Fecha de Registro",
    Bonus: "Bono",
    "Commission Payout": "Pago de Comisión",
    "Projected Commission": "Comisión Proyectada",
    "Total Commission paid": "Comisión Total Pagada",
    "Total Referrals": "Total de Referidos",
    "Frequently Asked Questions": "Preguntas Frecuentes",
    "What if a company cancels?": "¿Qué pasa si una empresa cancela?",
    "When do I receive my commission?": "¿Cuándo recibo mi comisión?",
    'Commissions are calculated monthly and paid out within 30 days after the end of each month. Pending commissions will be marked as "paid" once the payment is processed.':
      'Las comisiones se calculan mensualmente y se pagan dentro de los 30 días posteriores al final de cada mes. Las comisiones pendientes se marcarán como "pagadas" una vez que se procese el pago.',
    "What's the minimum payout amount?": "¿Cuál es el monto mínimo de pago?",
    "The minimum payout amount is $200. Once you reach this threshold, your earnings will be automatically processed for payment.":
      "El monto mínimo de pago es €200. Una vez que alcances este umbral, tus ganancias se procesarán automáticamente para el pago.",
    "How can I track my referrals?": "¿Cómo puedo rastrear mis referidos?",
    'You can track all your referrals and their status in the "My Earnings" section. This includes pending commissions, paid amounts, and detailed analytics of your referral performance.':
      'Puedes rastrear todos tus referidos y su estado en la sección "Mis Ganancias". Esto incluye comisiones pendientes, montos pagados y análisis detallados de tu rendimiento de referidos.',
    "Where can I find my referral code?":
      "¿Dónde puedes encontrar tu código de referido?",
    "Your unique referral code is displayed at the top of this page. Share this code with friends and family to start earning commissions when they sign up and subscribe.":
      "Tu código de referido único se muestra en la parte superior de esta página. Comparte este código con amigos y familiares para comenzar a ganar comisiones cuando se registren y se suscriban.",
    "Refer & Earn": "Referir y Ganar",
    "My Earnings": "Mis Ganancias",
    Dashboard: "Panel de Control",
    // AffiliateCommissionTrendsChart translations
    "Commission Trends": "Tendencias de Comisión",
    "Select Period": "Seleccionar Período",
    Daily: "Diario",
    Monthly: "Mensual",
    Commission: "Comisión",
    // AffiliateStats translations
    "Total Earnings": "Ganancias Totales",
    "Avg. Daily Earnings": "Ganancias Promedio Diarias",
    "Conversion Rate": "Tasa de Conversión",
    "Active Affiliates": "Afiliados Activos",
    "% from last month": "% del mes pasado",
    // RecentReferralTable translations
    "Recent Referrals": "Referidos Recientes",
    "See All": "Ver Todos",
    "You have no referrals at the moment. Please use the link below to onboard businesses.":
      "No tienes referidos en este momento. Por favor usa el enlace de abajo para incorporar empresas.",
    "N/A": "N/A",
    // RecentTransactions translations
    "Recent Transactions": "Transacciones Recientes",
    "No recent transactions found.":
      "No se encontraron transacciones recientes.",
    "Business Name": "Nombre del Negocio",
    Amount: "Monto",
    Status: "Estado",
    Date: "Fecha",
    pending: "pendiente",
    paid: "pagado",
    // SearchCompaniesTable translations
    "Search Query": "Consulta de Búsqueda",
    "Search for businesses (e.g., 'restaurant', 'coffee shop')":
      "Buscar empresas (ej., 'restaurante', 'cafetería')",
    Location: "Ubicación",
    "Search for a business location...": "Buscar ubicación de empresa...",
    "Business Type": "Tipo de Negocio",
    "Select business type": "Seleccionar tipo de negocio",
    "Search Radius (miles)": "Radio de Búsqueda (millas)",
    "Open Now": "Abierto Ahora",
    Companies: "Empresas",
    results: "resultados",
    "Error loading businesses:": "Error al cargar empresas:",
    'No businesses found for "{{query}}". Try adjusting your search criteria.':
      'No se encontraron empresas para "{{query}}". Intenta ajustar tus criterios de búsqueda.',
    "Enter a search query to find businesses.":
      "Ingresa una consulta de búsqueda para encontrar empresas.",
    "Company Name & Address": "Nombre y Dirección de la Empresa",
    Rating: "Calificación",
    Actions: "Acciones",
    "No rating": "Sin calificación",
    "View Profile": "Ver Perfil",
    "Visit Website": "Visitar Sitio Web",
    // ReferralLink translations
    Copied: "Copiado",
    Copy: "Copiar",
    "Download QR Code": "Descargar Código QR",
    // AffiliateSearchCompanies translations
    "Search Companies": "Buscar Empresas",
    // AffiliateProfileSettings translations
    Settings: "Configuración",
    // AffiliateTransactions translations
    Transactions: "Transacciones",
    "Search business name": "Buscar nombre del negocio",
    "Payment #": "Pago #",
    "Transaction ID": "ID de Transacción",
    // ForgotPassword translations
    "Forgot Password": "Olvidaste tu Contraseña",
    "Forgot your password? Let's get you back on the track.":
      "Introduce tu correo y te enviaremos un código de un solo uso para restablecer la contraseña.",
    "Remembered your account?": "¿Recordaste tu cuenta?",
    Next: "Siguiente",
    "OTP has been sent to your email":
      "OTP ha sido enviado a tu correo electrónico",
    "Failed to send OTP": "Error al enviar OTP",
    // SignUp page translations
    "Already have an account?": "¿Ya tienes una cuenta?",
    "Sign up If you don't have an account":
      "Regístrate si no tienes una cuenta",
    // AffiliateSignUpForm translations
    "Full Name": "Nombre Completo",
    "Enter Your Full Name": "Ingresa Tu Nombre Completo",
    "Confirm Password": "Confirmar Contraseña",
    "Confirm Your Password": "Confirma Tu Contraseña",
    "Or Sign up with": "O Regístrate con",
    // ResetPassword translations
    "Reset Password": "Restablecer Contraseña",
    "Reset your password? Let's get you back on the track.":
      "¿Restablecer tu contraseña? Te ayudaremos a volver al camino.",
    "Enter New Password": "Ingresa Nueva Contraseña",
    "Password reset successfully!": "¡Contraseña restablecida exitosamente!",
    "Failed to reset password": "Error al restablecer la contraseña",
    "Confirm Password is required": "Confirmar contraseña es requerido",
    // VerifyOtp translations
    "Verify OTP": "Verificar OTP",
    "Enter the OTP sent to your email to continue":
      "Ingresa el OTP enviado a tu correo electrónico para continuar",
    "Enter OTP": "Ingresa OTP",
    "Enter 4-digit code": "Ingresa código de 4 dígitos",
    "OTP is required": "OTP es requerido",
    "OTP must be 4 digits": "OTP debe tener 4 dígitos",
    "Resend OTP": "Reenviar OTP",
    "OTP verified successfully!": "¡OTP verificado exitosamente!",
    "Failed to verify OTP": "Error al verificar OTP",
    "OTP resent successfully!": "¡OTP reenviado exitosamente!",
    "Failed to resend OTP": "Error al reenviar OTP",
    // ViewBusinessProfileModal translations
    "Loading...": "Cargando...",
    Open: "Abierto",
    "Loading business details...": "Cargando detalles del negocio...",
    "Error loading business details:": "Error al cargar detalles del negocio:",
    "Operating Hours": "Horario de Operación",
    "Hours not available": "Horarios no disponibles",
    Closed: "Cerrado",
    "Contact Information": "Información de Contacto",
    "Recent Reviews": "Reseñas Recientes",
    Showing: "Mostrando",
    of: "de",
    reviews: "reseñas",
    "View all": "Ver todas las",
    "reviews on Google": "reseñas en Google",
    "View Profile on Google": "Ver Perfil en Google",
    // PageNotFound translations
    "Looks like you've gotten lost! The page you requested is unavailable":
      "¡Parece que te has perdido! La página que solicitaste no está disponible",
    "Head back to the homepage.": "Regresa a la página principal.",
    "Page not found": "Página no encontrada",

    "Open menu": "Abrir menú",
    "Close menu": "Cerrar menú",
    // DashboardLayout navigation translations
    Menu: "Menú",
    Others: "Otros",
    Referrals: "Referidos",
    Logout: "Cerrar sesión",
    "Please complete your affiliate profile setup":
      "Completa la configuración de tu perfil de afiliado",
    "You have not completed your affiliate profile, please complete it to continue using the platform.":
      "Aún no has completado tu perfil de afiliado; complétalo para seguir usando la plataforma.",
    "Complete Profile": "Completar perfil",
    "Confirm Logout?": "¿Confirmar cierre de sesión?",
    "Do you want to exit from app?": "¿Deseas salir de la aplicación?",
    "No, keep using app": "No, seguir usando la app",
    Yes: "Sí",
  },
};
